import { ActivatedRoute } from '@angular/router';
import { Contribution } from './../track/contribution';
import { AuthService } from './../user/auth.service';
import { RegistryService } from './../registry/registry.service';
import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { Settings } from '../settings/settings';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { UserService } from '../user/user.service';

@Component({
  selector: 'app-account-fees',
  templateUrl: './account-fees.component.html',
  styleUrls: ['./account-fees.component.scss']
})
export class AccountFeesComponent implements OnInit {

  public settings: Settings;
  valueChanged = false;
  public saved = false;
  feeOption: number;
  public hitchdForm: FormGroup;
  private selectionMade = false;
  coupleFee: number;
  guestFee: number;
  processing = false;
  percentFee = 0;
  fixedFee = '';
  contributions: Contribution[];
  headerLoaded= false;
  loaded = false;
  gifts: Gift[];
  registry: Registry;
  feeString = '';
  feeStringShort = '';
  extraInternationalCardPercent = 0;
  extraEeaCardPercent = 0;
  extraUkCardPercent = 0;
 euCountries = [
    'AL',
    'AD',
    'AM',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FO',
    'FI',
    'FR',
    'GB',
    'GE',
    'GI',
    'GR',
    'HU',
    'HR',
    'IE',
    'IS',
    'IT',
    'LT',
    'LU',
    'LV',
    'MC',
    'MK',
    'MT',
    'NO',
    'NL',
    'PO',
    'PT',
    'RO',
    'RU',
    'SE',
    'SI',
    'SK',
    'TR',
    'UA',
    'VA'
  ];
  currentPosition: number;
  hideMobileMenu: boolean;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {
   
    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;
    
  }
  constructor(
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private route: ActivatedRoute,
    private _userService: UserService
  ) {


    document.title = 'Account | Hitchd';
    this._authService.user.subscribe(user => {
      this._registryFirebaseService.initGiftsForUser(user);
    });

  }

  ngOnInit() {
    this._registryService.setScrollY(1);

    this.registry = this.route.snapshot.data.registry;

if (this.registry.paid !== undefined){
  this.getFees(this.registry.country);
}

    this.hitchdForm = this._fb.group({
      feeOption: [1, [Validators.required]],
    });
    this.load();
}

  handleLoaded(){

    
  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  getFees(country) {

    this.percentFee = 0 ;
    this.extraInternationalCardPercent = 0;
    this.extraEeaCardPercent = 0;
    this.extraUkCardPercent = 0;
    this.fixedFee = '';

      switch (country) {
        case 'AU': {
            this.percentFee = 1.75;
            this.extraInternationalCardPercent = 3.5 - this.percentFee;
            this.fixedFee = '0.30';
            break;
          }
          case 'MX': {
            this.percentFee = 3;
            this.extraInternationalCardPercent = 0;
            this.fixedFee = '3';
            break;
          }
          case 'DK': {
            this.percentFee = 1.4;
            this.extraUkCardPercent = 1.1;
            this.extraInternationalCardPercent = 2.9 - this.percentFee;
            this.fixedFee = '1.8';
            break;
          }
          case 'US': {
            this.percentFee = 2.9;
            // no fee if diff card
            this.extraInternationalCardPercent = 3.9 - this.percentFee;
            this.fixedFee = '0.30';
            break;
          }
          case 'CA': {
            this.percentFee = 2.9;
            this.extraInternationalCardPercent = 3.5 - this.percentFee;
            this.fixedFee = '0.30';
            break;
          }
          case 'NZ': {
            this.percentFee = 2.9;
            this.fixedFee = '0.30';
            break;
          }
          case 'HK': {
            this.percentFee = 3.4;
            this.fixedFee = '0.30';
            break;
          }
          case 'GB': {
            this.percentFee = 1.4;
            this.extraEeaCardPercent = 1.1
            this.extraInternationalCardPercent = 2.9 - this.percentFee;
            this.fixedFee = '0.20';
            break;
          }
          case 'NO': {
            this.percentFee = 2.4;

            this.extraInternationalCardPercent = 2.9 - this.percentFee;
            this.fixedFee = '2';
            break;
          }
          case 'SW': {
            this.percentFee = 1.4;
            this.extraUkCardPercent = 1.1;
            this.extraInternationalCardPercent = 2.9 - this.percentFee;
            this.fixedFee = '1.8';
            break;
  
          }
          case 'SH': {
            this.percentFee = 1.4;

            this.extraInternationalCardPercent = 2.9 - this.percentFee;
            this.fixedFee = '1.8';
            break;
          }
          case 'JP': {
            this.percentFee = 3.6;
            this.fixedFee = '';
            break;
          }
          case 'SG': {
            this.percentFee = 3.4;
            this.fixedFee = '0.50';
            break;
          }
          case 'IE': {
            this.percentFee = 1.5;
            this.extraUkCardPercent = 1;
            this.extraInternationalCardPercent = 3.25 - this.percentFee;
            this.fixedFee = '0.25';
            break;
          }
          
          default: {
            this.percentFee = 1.5;
            this.extraUkCardPercent = 1;
            this.extraInternationalCardPercent = 3.25 - this.percentFee;
            this.fixedFee = '0.25';
            break;
          }

  }
// this.extraInternationalCardPercent = parseFloat(this.extraInternationalCardPercent, 0).toFixed(2);
  this.feeString = `${this.percentFee}% + ${this.registry.symbol}${this.fixedFee} ${this.registry.currency}`;
  this.feeStringShort = `${this.percentFee}% + ${this.registry.symbol}${this.fixedFee}`;
  if (!this.fixedFee){
  this.feeString = `${this.percentFee}%`;
  this.feeStringShort = this.feeString;
  }
}

 isEu(country) {
  return this.euCountries.includes(country);
}

  selectFee(feeOption: number){
    this.hitchdForm.controls['feeOption'].setValue(feeOption);
    this.valueChanged = true;
    this.feeOption = feeOption;
    this.guestFee = this.getGuestFee(this.feeOption);
    this.coupleFee = this.getCoupleFee(this.feeOption);
  }

  getGuestFee(feeOption: number) {
    switch (feeOption) {
      case 1: { return 0; }
      case 2: { return 4; }
      case 3: { return 8; }
    }
  }

  getCoupleFee(feeOption: number){
    switch (feeOption) {
      case 1: { return 8; }
      case 2: { return 4; }
      case 3: { return 0; }
    }
  }
  load() {


    this.contributions = this.route.snapshot.data.contributions;
    this.gifts = this.route.snapshot.data.gifts;
    this._registryFirebaseService.getContributions(this.gifts).subscribe(contribution => {


      this.contributions = this.contributions;
    });
    this._registryFirebaseService.currentSettings.subscribe(
      response => {

        this.settings = response;
        if (this.settings) {
          this.feeOption = this.settings.feeOption;
          this.hitchdForm.controls['feeOption'].setValue(response.feeOption);
          this.guestFee = this.getGuestFee(this.feeOption);
          this.coupleFee = this.getCoupleFee(this.feeOption);
        }

        this._registryFirebaseService.killLoader();
        
    this.loaded = true;
      });
  }
  save() {
    this.processing = true;
    if (!this.settings) {
      this.settings = new Settings();
    }
    this.settings.feeOption = this.hitchdForm.controls['feeOption'].value;
    this._registryFirebaseService.saveSettings(this.settings);
    this.valueChanged = false;
    this.saved = true;

    setTimeout(() => {
      this.processing = false;
    }, 1 * 1000);
  }




  makeSelection() {
    this.valueChanged = true;
  }



}



// WEBPACK FOOTER //
// ./src/app/account-fees/account-fees.component.ts